import { render } from "./myClient.vue?vue&type=template&id=61606f3f&ts=true"
import script from "./myClient.vue?vue&type=script&lang=ts&config=true"
export * from "./myClient.vue?vue&type=script&lang=ts&config=true"

import "./myClient.vue?vue&type=style&index=0&id=61606f3f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__